var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      editForm: _vm.isEdit
    }
  }, [(_vm.isSimple) ? _c('society-form-simple', {
    ref: "form",
    attrs: {
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : _c('div', [(_vm.isFull) ? _c('div', [(!_vm.typeList.includes(_vm.scoreType)) ? _c('society-form-more', {
    ref: "form",
    attrs: {
      "isEdit": _vm.isEdit,
      "advise": _vm.advise,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (['4', '9'].includes(_vm.scoreType)) ? _c('society-form-recruitment-guangzhou', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (['5', '10', '17', '21', '22', '23', '24'].includes(_vm.scoreType)) ? _c('society-form-recruitment-hangzhou', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "turn": _vm.turn,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (_vm.scoreType === '6') ? _c('society-form-social-notqa', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (_vm.scoreType === '7') ? _c('society-form-social-qa', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (_vm.scoreType === '8') ? _c('society-form-verify-qa', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType,
      "scoreType": _vm.scoreType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : (['11', '12', '13'].includes(_vm.scoreType)) ? _c('society-form-pma', {
    ref: "form",
    attrs: {
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo,
      "scoreType": _vm.scoreType,
      "turn": _vm.turn
    },
    on: {
      "refresh": _vm.refresh,
      "cancel": _vm.cancel
    }
  }) : (['14', '15', '16', '18', '19', '20'].includes(_vm.scoreType)) ? _c('society-form-2021-qa', {
    ref: "form",
    attrs: {
      "scoreType": _vm.scoreType,
      "turn": _vm.turn,
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : _c('society-form-simple', {
    ref: "form",
    attrs: {
      "advise": _vm.advise,
      "isEdit": _vm.isEdit,
      "extInfo": _vm.extInfo
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  })], 1) : _c('div', [(_vm.scoreType) ? _c('society-form', {
    ref: "form",
    attrs: {
      "isEdit": _vm.isEdit,
      "advise": _vm.advise,
      "extInfo": _vm.extInfo,
      "recruitType": _vm.recruitType
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  }) : _c('society-form-simple', {
    ref: "form",
    attrs: {
      "isEdit": _vm.isEdit,
      "advise": _vm.advise,
      "extInfo": _vm.extInfo
    },
    on: {
      "cancel": _vm.cancel,
      "refresh": _vm.refresh
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e0f9a22"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/evaluation/society-form/society-form.vue
// module id = null
// module chunks = 